module.exports = __webpack_public_path__ + "img/square-up-left.7cc90bf1.svg";